import { useEffect, useState, memo } from "react";
import PropTypes from "prop-types";
import L from "leaflet";

import { fetchIcon, getIcon } from "./icons";

function PointBody({
    map,
    transport,
    getTimeOffset,
    isTrackShowing,
    isTrackShown,
    isPopupShown,
    renderTime,
    showPopup,
    hidePopup,
    hideTrackButtons,
}) {
    const { id, number, time, lng, lat, speed, company, iconUrl, type } =
        transport;

    const [marker, setMarker] = useState(null);
    const [iconReady, setIconReady] = useState(Boolean(getIcon(iconUrl)));

    useEffect(() => {
        if (!iconReady) {
            return undefined;
        }

        const marker = L.marker({ lat: 0, lng: 0 }, { icon: getIcon(iconUrl) })
            .bindPopup("", { autoPan: false })
            .addTo(map);

        marker.on("popupopen", () => {
            showPopup(id);
        });

        marker.on("popupclose", () => {
            hidePopup(id);
        });

        setMarker(marker);

        return () => {
            marker.removeFrom(map);
        };
    }, [id, iconUrl, iconReady, map, setMarker, showPopup, hidePopup]);

    useEffect(() => {
        if (marker) {
            const pointLatLng = marker.getLatLng();

            if (pointLatLng.lat !== lat || pointLatLng.lng !== lng) {
                marker.setLatLng({ lat, lng });
            }
        }
    }, [marker, lng, lat]);

    useEffect(() => {
        if (marker) {
            let toggleTrackLabel = "Показать трек";
            let linkClass = "show-track";

            if (isTrackShowing) {
                toggleTrackLabel = "Трек загружается...";
                linkClass = "hint-link";
            } else if (isTrackShown) {
                toggleTrackLabel = "Убрать трек";
                linkClass = "hide-track";
            }

            marker.setPopupContent(`
                Гос. номер: <b>${number}</b><br/>
                Тип.техники: <b>${type}</b><br/>
                Организация: <b>${company}</b><br/>
                Скорость: <b>${speed} км/ч</b><br/>
                Последние данные: <b>≈ ${getTimeOffset(time)}</b><br/>
                ${
                    hideTrackButtons
                        ? ""
                        : `<a class="${linkClass}" onclick="toggleHintTrack(this)" data-id="${id}">${toggleTrackLabel}</a>`
                }
            `);
        }
    }, [
        marker,
        getTimeOffset,
        id,
        number,
        time,
        speed,
        company,
        type,
        isTrackShowing,
        isTrackShown,
        renderTime,
    ]);

    useEffect(() => {
        if (marker && isPopupShown && !marker.isPopupOpen()) {
            marker.openPopup();
        }
    }, [marker, isPopupShown]);

    if (!iconReady) {
        fetchIcon(iconUrl).then(() => {
            setIconReady(true);
        });
    }

    return null;
}

PointBody.propTypes = {
    map: PropTypes.any.isRequired,
    transport: PropTypes.shape({
        id: PropTypes.number.isRequired,
        number: PropTypes.string.isRequired,
        time: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
        lat: PropTypes.number.isRequired,
        speed: PropTypes.number.isRequired,
        company: PropTypes.string.isRequired,
        iconUrl: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
    }).isRequired,
    getTimeOffset: PropTypes.func.isRequired,
    isTrackShowing: PropTypes.bool.isRequired,
    isTrackShown: PropTypes.bool.isRequired,
    isPopupShown: PropTypes.bool.isRequired,
    renderTime: PropTypes.number,
    showPopup: PropTypes.func.isRequired,
    hidePopup: PropTypes.func.isRequired,
    hideTrackButtons: PropTypes.bool,
};

const Point = memo(PointBody);

Point.propTypes = {
    map: PropTypes.any.isRequired,
    transport: PropTypes.shape({
        id: PropTypes.number.isRequired,
        number: PropTypes.string.isRequired,
        time: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
        lat: PropTypes.number.isRequired,
        speed: PropTypes.number.isRequired,
        company: PropTypes.string.isRequired,
        iconUrl: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
    }).isRequired,
    getTimeOffset: PropTypes.func.isRequired,
    isTrackShowing: PropTypes.bool.isRequired,
    isTrackShown: PropTypes.bool.isRequired,
    isPopupShown: PropTypes.bool.isRequired,
    renderTime: PropTypes.number,
    showPopup: PropTypes.func.isRequired,
    hidePopup: PropTypes.func.isRequired,
    hideTrackButtons: PropTypes.bool,
};

export { Point };
